// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__1yK5g","slider":"switch_slider__ZAa8P","input":"switch_input__2IiIq","round":"switch_round__Vg2qV"};